import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0f9acd70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h1--hero" }
const _hoisted_2 = { class: "hero-h-wrapper" }
const _hoisted_3 = {
  "data-w-id": "a57a7ba6-1456-df65-733e-c340ef917366",
  class: "h--super-large"
}
const _hoisted_4 = { class: "hero-h-wrapper" }
const _hoisted_5 = {
  "data-w-id": "201b457d-0993-bca7-76e5-88cdccd4a159",
  class: "h--super-large"
}

import { DocumentLayout } from "@/layout";
import ComplaintsCz from "@/locales/complaints/ComplaintsCz.vue";
import ComplaintsEn from "@/locales/complaints/ComplaintsEn.vue";
import { ref, computed, onMounted, watch } from "vue";
// import HomeAdapterService from "./home/adapter/HomeAdapterService";

// const adapter = new HomeAdapterService();

import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'ComplaintsDisclaimer',
  setup(__props) {

// Импорты из Vue 3 Composition API

const { locale } = useI18n();
const curLang = ref("cz");
onMounted(async () => {
  curLang.value = localStorage.getItem("locale") || "cz";
  locale.value = curLang.value;
});
const onShowAnswer = (id: string) => {};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DocumentLayout), null, {
    default: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("complaints.complaints")), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("complaints.disclaimer")), 1)
        ])
      ]),
      (_unref(locale) === 'en')
        ? (_openBlock(), _createBlock(ComplaintsEn, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(locale) === 'cz')
        ? (_openBlock(), _createBlock(ComplaintsCz, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})